module.exports = __webpack_public_path__ + "img/6.49d47402.svg";